<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input clearable disabled v-model="form.name" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话" prop="tel">
              <el-input clearable disabled v-model="form.tel" maxlength="100"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="主要症状" prop="mainSymptoms">
              <el-input clearable   placeholder="请输入主要症状" v-model="form.mainSymptoms" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="服药情况" prop="medication">
              <el-input clearable  placeholder="请输入服药情况" v-model="form.medication" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="随访方式" prop="followType">
              <el-select   v-model="form.followType" 
             
              
                placeholder="请选择随访方式"
              style="width:100%">
                <el-option
                  v-for="item in followTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
      
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="随访日期" prop="followDate">
              <el-date-picker
                v-model="form.followDate"
                style="width: 100%;"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择随访日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="随访人" prop="followPerson">
              <el-input clearable placeholder="请输入随访人" v-model="form.followPerson" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
         
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import { saveHealthFollow,updateHealthFollow } from '@/api/nursingHome/healthData.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    personData: {
      default: {},
    },
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      form: {
      
        mainSymptoms: '',
        medication: '',
        followType: '',
        followDate:'',
        followPerson:'',
      },
      formRules: {
        mainSymptoms: [{ required: true, message: '主要症状不能为空', trigger: 'blur' }],
        medication: [{ required: true, message: '服药情况不能为空', trigger: 'blur' }],
        followType: [{ required: true, message: '随访方式不能为空', trigger: 'change' }],
        followDate: [{ required: true, message: '随访日期不能为空', trigger: 'change' }],
        followPerson: [{ required: true, message: '随访人不能为空', trigger: 'blur' }]
      },
  
      
      followTypeList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    
    async initData() {
      getDictionary("nursinghome_follow_type").then((res) => {
        this.followTypeList = res.data
      })
      if(this.model != 'add') {
      this.form = Object.assign({},this.row)   
      }
      console.log("person",this.personData)
      this.form.name = this.personData.name
      this.form.elderlyId= this.personData.id
      this.form.nursinghomeId= this.personData.nursinghomeId
      this.form.tel= this.personData.tel
     
    },
    saveRecord() {
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            saveHealthFollow(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            updateHealthFollow(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
